
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BarChart3, CheckCircle, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useUserProgress } from "@/hooks/use-user-progress";

export const BusinessAssessmentCard = () => {
  const navigate = useNavigate();
  const { progress } = useUserProgress();

  const handleStartAssessment = () => {
    navigate("/assessment");
  };

  return (
    <Card className="border-blue-200">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <BarChart3 className="h-5 w-5 text-blue-600" />
          Business Assessment
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {progress.hasCompletedAssessment ? (
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-green-600">
              <CheckCircle className="h-4 w-4" />
              <span className="text-sm font-medium">Assessment Complete</span>
            </div>
            <p className="text-sm text-gray-600">
              Your business profile is ready! Use it to generate personalized strategic documents.
            </p>
            <Button 
              onClick={handleStartAssessment}
              variant="outline" 
              size="sm" 
              className="w-full"
            >
              Update Assessment
            </Button>
          </div>
        ) : (
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-amber-600">
              <Clock className="h-4 w-4" />
              <span className="text-sm font-medium">Assessment Pending</span>
            </div>
            <p className="text-sm text-gray-600">
              Complete your business assessment to unlock personalized AI recommendations and document generation.
            </p>
            <Button 
              onClick={handleStartAssessment}
              className="w-full bg-blue-600 hover:bg-blue-700"
              size="sm"
            >
              Start Assessment
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
